import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertMessageService } from '@serpro/ngx-suite-rfb';
import { StringUtil } from 'src/app/shared/util/string.util';
import { AuthService } from '../../auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    nextRoute: string;
    urlCertificado: string;
    message = 'Verifique os dados informados.';
    exibirTela = false;

    constructor(
        private alertMessageService: AlertMessageService,
        private authService: AuthService,
        private router: Router,
        private activatedRoute: ActivatedRoute) { }

    ngOnInit() {

        if (environment.apiUrl.includes("localhost")) {
            this.router.navigate([this.nextRoute ? this.nextRoute : '/dashboard']);
        }

        this.getUrlCertificado();

        let token;
        let erro;
        this.activatedRoute.queryParams.subscribe(params => {
            this.nextRoute = params['nextRoute'];
            token = params['token'];
            erro = params['erro'];
        });

        console.log('token', token);
        if (erro) {
            console.log('erro', erro);
        }

        if (token) {
            this.authService.logarComCertificado(token);
            this.router.navigate([this.nextRoute ? this.nextRoute : '/dashboard']);
        } else {
            this.exibirTela = true;
            if (erro) {
                const decodedMsg = decodeURIComponent(erro);
                console.log('decodedMsg', decodedMsg);
                const msg = this.tratarErros(decodedMsg, this.message);
                this.alertMessageService.error('Falha no login', msg);
            }
        }
    }

    getUrlCertificado() {
        this.authService.getUrlAuthCertificado().subscribe({
            next: retorno => {
                this.urlCertificado = retorno.mensagem + '/certificado';
            }
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private tratarErros(errorDetail: any, msgDefault: string): string {

        if (!errorDetail) {
            return msgDefault;
        }

        let message = '';
        console.log('Falha na autenticação', errorDetail);

        if (StringUtil.contem(errorDetail, 'REVOGADO')) {
            message = 'Usuário revogado no Senha Rede.';
        } else if (StringUtil.contem(errorDetail, 'EXPIRADA')) {
            message = 'Senha expirada no Senha Rede.';
        } else if (StringUtil.contem(errorDetail, 'INDISPONIVEL')) {
            message = 'Serviço de autenticação do Senha Rede indisponível. Por favor, tente novamente mais tarde. ';
        } else if (StringUtil.contem(errorDetail, 'NOVA SENHA MENOR QUE 6')) {
            message = 'Nova senha deve ter no mínimo 6 caracteres.';
        } else if (StringUtil.contem(errorDetail, 'NOVA SENHA IGUAL A UMA DAS TRES ULTIMAS')) {
            message = 'Nova senha é igual a uma das três últimas.';
        } else if (StringUtil.contem(errorDetail, 'NOVA SENHA DEVE TER LETRAS E NUMEROS')) {
            message = 'Nova senha deve ter letras e números.';
        } else if (StringUtil.contem(errorDetail, 'NOVA SENHA TEM CARACTERES REPETIDOS')) {
            message = 'Nova senha tem caracteres repetidos.';
        } else if (StringUtil.contem(errorDetail, 'SENHA NAO OK')) {
            message = 'A senha informada não confere.';
        } else if (StringUtil.contem(errorDetail, 'HABILITACAO NAO OK')) {
            message = 'Usuário não habilitado no sistema.';
        } else if (StringUtil.contem(errorDetail, 'USUARIO NAO CADASTRADO')) {
            message = 'Usuário não cadastrado no sistema.';
        } else if (StringUtil.contem(errorDetail, 'O DO CERTIFICADO DO SERVIDOR')) {
            message = 'Certificado do usuário não cadastrado no Senha Rede.';
        } else if (StringUtil.contem(errorDetail, 'Unauthorized')) {
            message = 'Usuário não autorizado.';
        } else {
            message = errorDetail;
        }
        return message;
    }
}
